module.exports = __webpack_public_path__ + "images/podcast_600.660bb5dd4a7c2700fd30b0c3c6b3ebb9.png";